import { useEffect } from 'react'
import { track, TrackingEvent } from '../../tracking'

export function useTrackingEvent(event: string | TrackingEvent): void {
  useEffect(() => track(event), [event])
}
